<template>
  <div class="settings-templateConfigDetail">
    <templateConfigDetail :template-options="emailTypes" />
  </div>
</template>

<script>
import templateConfigDetail from '@/components/templateConfig/templateConfigDetail.vue'
import templateConfigMixin from '@/mixins/templateConfig'
export default {
  name: 'SettingsTemplateConfigDetail',
  components: {
    templateConfigDetail
  },
  mixins: [templateConfigMixin],
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
